import { gqlCountryEnum as country } from '@minecraft.graphql-types';
import _includes from 'lodash/includes';

export const getSize = (profileCountry, value) => {
  switch (profileCountry) {
    case country.US:
    case country.CA:
      return value.sizeUS;
    case country.GB: // Great Britain has UK sizes
    case country.IE: // Ireland has UK sizes
      return value.sizeUK;
    case country.AU:
    case country.NZ: // NZ has AU sizes
      return value.sizeAU;
    default:
      return value.sizeEU;
  }
};

export const getShoeSize = (profileCountry, value) => {
  switch (profileCountry) {
    case country.US:
    case country.CA:
      return value.shoeSizeUS;
    case country.GB: // Great Britain has UK sizes
    case country.IE: // Ireland has UK sizes
      return value.shoeSizeUK;
    case country.AU:
    case country.NZ: // NZ has AU sizes
      return value.shoeSizeAU;
    default:
      return value.shoeSizeEU;
  }
};

export const arrayToSelectOptions = <T extends { id: string | number; name: string | number }>(array: T[]) =>
  array.map((value) => ({
    value: value.id?.toString(),
    label: value.name?.toString(),
  }));

export const arrayWithDefaultOptions = <T extends { value: string | number; label: string | number }>(array: T[]) => {
  return [{ value: '', label: '' }, ...array];
};

export const arrayToUSCountrySelectOptions = (isUSCountry, array) =>
  array.map((value) => ({
    value: value.id,
    label: isUSCountry ? value.inch : value.cm,
  }));

export const arrayToAllCountrySelectOptions = (profileCountry, array) =>
  array.map((value) => ({
    value: value.id,
    label: getSize(profileCountry, value),
  }));

export const arrayToAllCountryShoeSizeSelectOptions = (profileCountry, array) =>
  array.map((value) => ({
    value: value.id,
    label: getShoeSize(profileCountry, value),
  }));

export const arrayToHatSizeSelectOptions = (isUSCountry, array) =>
  array.map((value) => ({
    value: value.id,
    label: isUSCountry ? value.inch : value.cm,
  }));

export const includesAll = (wholeArray, partOfWholeArray) => {
  const notContainedElement = partOfWholeArray.find((arrayElement) => !_includes(wholeArray, arrayElement));

  return notContainedElement === undefined;
};
